export interface ProtocolAdapter {
  getUniversalMappedPoints: (sourceData: any) => Record<string, any>;
  getOperationalValue: (
    propertyKey: string,
    universalMappedPoints: Record<string, any>,
    operationalData: Record<string, any>
  ) => any;
  formatValue: (currentValue: any, config: any, systemEnum?: any) => any;
  buildPointKey: (identifier: any) => string;
  prepareValue?: (identifier: any, value: any) => any;
}

export const formatValue = (currentValue: any, config: any, systemEnum: any = null) => {
  if (config?.propertyMapping) {
    const { propertyMapping } = config;
    const universalKey = Object.keys(propertyMapping).find(
      (key) => String(propertyMapping[key]) === String(currentValue)
    );

    if (universalKey !== undefined && systemEnum?.[universalKey]) {
      return systemEnum[universalKey];
    }
  }

  const numValue = Number(currentValue);
  if (config?.customEnum?.[numValue]) {
    return config?.customEnum[numValue];
  }
  if (isNaN(numValue)) {
    return currentValue;
  }
  return Number.isInteger(numValue) ? String(numValue) : numValue.toFixed(1);
};

export const getUniversalMappedPoints = (paramTemplateData: any): Record<string, any> => {
  if (!paramTemplateData) {
    return {};
  }
  const mappedPoints: Record<string, any> = {};
  Object.entries(paramTemplateData).forEach(([objectId, pointData]: [string, any]) => {
    if (pointData?.property) {
      mappedPoints[pointData.property] = {
        objectId,
        ...pointData,
      };
    }
  });
  return mappedPoints;
};

export const getOperationalValue = (
  propertyKey: string,
  universalMappedPoints: Record<string, any>,
  operationalData: Record<string, any>
) => {
  const point = universalMappedPoints[propertyKey];
  if (!point?.objectId) {
    return null;
  }
  const dataKey = `${point.objectId}/85`;
  return operationalData?.[dataKey] ?? operationalData?.[point.objectId] ?? null;
};

export const prepareObjectValue = (objectId: string, value: any) => {
  try {
    if (objectId && objectId.startsWith('binary')) {
      if (value === 1 || value === '1' || value === true || value === 'ON' || value === 'on') {
        return 1;
      }
      return 0;
    }
  } catch (error) {
    // Parsing error fallback
  }
  return value;
};

export const bacnetAdapter: ProtocolAdapter = {
  getUniversalMappedPoints,
  getOperationalValue,
  formatValue,
  buildPointKey: (objectId: string) => `${objectId}/85`,
  prepareValue: prepareObjectValue,
};
